import { commonOptions } from 'amb/options/common.options';

export default {
  /**
   * Add the hidden class to the collapse element if the user hides it
   */
  main() {
    $('body')
      .on('hidden.bs.collapse show.bs.collapse', (event) => {
        event.target.classList.toggle('hide', event.type === 'hidden');
      })
      .on('shown.bs.collapse', (event) => {
        event.target.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      })
    ;
  },

  /**
   * Add the show class to the collapse element if the media query matches
   */
  handleShowClass() {
    document
      .querySelectorAll('.collapse[class*="show-"]')
      .forEach((element) => {
        const showClasses = element.className.match(/show-(\w+)/g) || [];

        element.classList.remove('show');
        for (const showClass of showClasses) {
          const screenWidth = (commonOptions.breakpoints)[showClass.replace('show-', '')];
          const mediaQueryList = window.matchMedia(`(min-width: ${screenWidth}px)`);

          if (mediaQueryList.matches) {
            element.classList.add('show');
            break;
          }
        }
      })
    ;
  },

  /**
   * Remove the show class from the collapse element if the media query matches
   */
  handleHideClass() {
    document
      .querySelectorAll('.collapse[class*="hide-"]')
      .forEach((element) => {
        const hideClasses = element.className.match(/hide-(\w+)/g) || [];

        element.classList.add('show');
        for (const hideClass of hideClasses) {
          const screenWidth = (commonOptions.breakpoints)[hideClass.replace('hide-', '')];
          const mediaQueryList = window.matchMedia(`(max-width: ${screenWidth}px)`);

          if (mediaQueryList.matches) {
            element.classList.remove('show');
            break;
          }
        }
      })
    ;
  }
};
